module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S9 Sunrise Gold.4e820d28.png";